import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import {useGetAllStatesQuery, useGetStateByIdQuery} from "../../states/statesApi";
import SelectField from "../../../../components/common/form/SelectField";
import {createOptionListForSelectTag} from "../../../../helpers/utils/Utils";
import {useGetAllCountyByStateIdQuery} from "../../counties/countiesApi";
import {skipToken} from "@reduxjs/toolkit/query";
import {useCreateCollectorMutation} from "../collector";
import {useNavigate, useParams} from "react-router-dom";
import {FaLink, FaPlus, FaSearch, FaTimes} from "react-icons/fa";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {useSearchTaxRoundingConfigQuery} from "../../taxRoundingConfig/taxRoundingConfigApi";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import IconButton from "../../../../components/common/form/IconButton";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import NumberFormatField from "../../../../components/common/form/NumberFormatField";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import TextAreaField from "../../../../components/common/form/TextAreaField";
import {Routes as AppRoutes} from "../../../../routes";
import {FaMagnifyingGlass} from "react-icons/fa6";

const CreateCollector = () => {

    const [selectedRowData, setSelectedRowData] = useState<any>({});

    const [collectorsData, setCollectorsData] = useState<any>({});

    const navigate = useNavigate();
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateIdQuery(collectorsData?.state?.value ?? skipToken);
    const [createCollectorApi, createCollectorApiResponse] = useCreateCollectorMutation()
    const [crumbs, setCrumbs] = useState<any[]>([])

    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const {data: enums} = useGetEnumsQuery("");
    const {data: stateById} = useGetStateByIdQuery(collectorsData?.state?.value ?? skipToken);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [showConfigModal, setShowConfigModal] = useState<boolean>(false);
    useEffect(() => {

        setCrumbs([
            {content: "Home", url: "/home"},
            {content: "Collectors", url: "/collectors"},
            {content: "Add Collector", url: ""}
        ])

    }, []);

    const handleOnChange = (
        e:
            | ChangeEvent<HTMLInputElement>
            | ChangeEvent<HTMLTextAreaElement>
            | { name: string; value: any }
    ) => {
        const {name, value} = 'target' in e ? e.target : e;

        if (name === "state" && (value === " " || value === null || value === "")) {
            setCollectorsData((prev: any) => ({
                ...prev,
                counties: "",
            }));
        }

        setCollectorsData((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            name: collectorsData?.name,
            isPrimaryCollector: collectorsData?.isPrimaryCollector,
            setTaxSuitCollector: collectorsData?.isTaxSuitCollector,
            state: {
                id: collectorsData.state.value
            },
            countyId: collectorsData?.counties?.value,
            contact: {
                name: collectorsData?.name,
                website: collectorsData?.website,
                phone: collectorsData?.phone,
                fax: collectorsData?.fax,
                preferredContactMethod: collectorsData?.preferredContactMethod?.value,
                note: collectorsData?.note,
                address: {
                    mailingAddress: collectorsData?.mailingAddress,
                    zipCode: collectorsData.zipCode,
                    city: collectorsData.city,
                    state: stateById?.stateAbbreviation
                }
            },
            payableTo: collectorsData?.payableTo,
            taxRoundingConfigurationId: selectedRowData?.id

        }
        const CreateCollectorData = async () => {
            return await createCollectorApi({
                ...obj,
            }).unwrap();
        };
        await handleRTKQuery(CreateCollectorData, (response: any) => {
            if (response?.success || response?.data?.success) {
                setCollectorsData({});
                navigate(AppRoutes.Collector.path);
            }
        });
    }


    const handleToggle = (property: string) => (e: any) => {
        setCollectorsData((prevData: any) => ({
            ...prevData,
            [property]: !prevData[property]
        }));
    };


    const handleClear = () => {
        setCollectorsData((prevData: any) => ({
            ...prevData,
            taxRoundingConfig: '',
        }));
    };


    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        setCollectorsData({
            ...collectorsData,
            taxRoundingconfig: selectedRow.name
        })
        setShowConfigModal(false)
    }

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''}/>
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        }
    ]

    return (
        <>
            <div className="px-4 py-2">
                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs}/>
                </div>
                <div className="flex justify-center mt-3 text-sm">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-5">Add
                            Collector
                        </h3>
                        <Form
                            onSubmit={handleSubmit}
                            fields={
                                <>
                                    <InputField name="name"
                                                label="Name" value={collectorsData?.name || ""}
                                                onChange={handleOnChange}
                                                required
                                                placeholder="Enter Name..."/>

                                    <InputField
                                        name="taxRoundingconfig"
                                        label="Tax Rounding Configr"
                                        onChange={handleOnChange}
                                        value={collectorsData?.taxRoundingconfig || ""}
                                        type="text"
                                        placeholder="Enter Tax Rounding Config..."
                                        onClick={() => {
                                            setShowConfigModal(true);
                                        }}
                                        className="cursor-pointer"
                                        icon={<IconButton
                                            icon={<FaLink onClick={() => {
                                                if (selectedRow?.id) {
                                                    window.open(`/tax-rounding-config/${selectedRow.id}`, '_blank');
                                                }
                                            }}/>
                                            }
                                            className={`text-sm ${collectorsData?.taxRoundingconfig ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                            }`}
                                            title={"Go to Tax Config Detail"}
                                        />}
                                        inputIcon={
                                            collectorsData?.taxRoundingconfig ? (
                                                    <FaTimes
                                                        className={iconButtonStyle}
                                                        title="Clear Data"
                                                        onClick={() => {
                                                            handleClear();
                                                        }}
                                                    />

                                                ) :
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Tax Config Detail"
                                                    onClick={() => {
                                                        setShowConfigModal(true);
                                                    }}
                                                />


                                        }
                                    />

                                    <InputField
                                        name="isTaxSuitCollector"
                                        label="Tax Suit Collector"
                                        type="checkbox"
                                        checked={collectorsData?.isTaxSuitCollector}
                                        onChange={handleToggle("isTaxSuitCollector")}
                                        className="mt-7"
                                    />

                                    <InputField
                                        name="isPrimaryCollector"
                                        label="Primary Collector"
                                        type="checkbox"
                                        checked={collectorsData?.isPrimaryCollector}
                                        onChange={handleToggle("isPrimaryCollector")}
                                        className="mt-7"
                                    />

                                    <SelectField
                                        placeholder='Select State...'
                                        value={collectorsData?.state}
                                        options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                        onChange={(selectedOption) => {
                                            handleOnChange({name: "state", value: selectedOption})
                                        }}
                                        label={"Select State"}
                                        required
                                    />


                                    {collectorsData?.isPrimaryCollector && (
                                        <>
                                            <SelectField
                                                placeholder='Select County...'
                                                value={collectorsData?.counties}
                                                options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                                onChange={(selectedOption) => {
                                                    handleOnChange({name: "counties", value: selectedOption})
                                                }}
                                                label={"County"}
                                                isDisabled={!collectorsData?.state}
                                                required

                                            />

                                            <InputField name="city"
                                                        label="City" value={collectorsData?.city || ""}
                                                        onChange={handleOnChange}

                                                        placeholder="Enter City..."/>
                                        </>
                                    )}


                                    <InputField name="contactName"
                                                label="Contact Name" value={collectorsData?.contactName || ""}
                                                onChange={handleOnChange}
                                                required
                                                placeholder="Enter Contact Name..."/>

                                    <InputField name="mailingAddress"
                                                label="Mailing Address" value={collectorsData?.mailingAddress || ""}
                                                onChange={handleOnChange}
                                                required
                                                placeholder="Enter Mailing Address..."/>

                                    <NumberFormatField
                                        className=""
                                        placeholder="Enter Phone..."
                                        name="phone"
                                        value={collectorsData?.phone || ""}
                                        onChange={handleOnChange}
                                        label={"Phone"}
                                        required
                                    />
                                    <InputField name="email"
                                                label="Email" value={collectorsData?.email || ""}
                                                onChange={handleOnChange}
                                                placeholder="Enter email..."/>

                                    <InputField name="website"
                                                label="Website" value={collectorsData?.website || ""}
                                                onChange={handleOnChange}
                                                placeholder="Enter Website..."/>

                                    <NumberFormatField className="" placeholder="Enter Fax..."
                                                       value={collectorsData?.fax || ""}
                                                       onChange={handleOnChange}
                                                       name="fax"
                                                       label={"Fax"}
                                    />

                                    <InputField name="zipCode"
                                                label="Zip code" value={collectorsData?.zipCode || ""}
                                                onChange={handleOnChange}
                                                placeholder="Enter Zip Code..."/>

                                    <SelectField
                                        placeholder='Select Contact Method...'
                                        value={collectorsData?.contactMethod || null}
                                        options={createOptionListForSelectTag(enums?.["ContactMethod"], "value", "constant")}
                                        onChange={(selectedOption) => {
                                            handleOnChange({name: "contactMethod", value: selectedOption})
                                        }}
                                        label={"Contact Method"}
                                    />
                                    <TextAreaField
                                        label="Note"
                                        name="note"
                                        value={collectorsData?.note || ""}
                                        className="mb-2 text-surface-2"
                                        onChange={handleOnChange}
                                    />

                                    <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                        <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        </div>
                                        <div className="relative col-span-9">
                                            <div className={"mt-4 flex"}>
                                                <ButtonTray
                                                    buttons={[
                                                        {
                                                            buttonProps: {
                                                                btnText: "Cancel",
                                                                onClick: () => navigate(AppRoutes.Collector.path),
                                                                type: "close",
                                                            },
                                                            buttonType: "button"
                                                        },
                                                        {
                                                            buttonProps: {
                                                                btnText: "Submit",
                                                                type: "submit",
                                                                isLoading: (createCollectorApiResponse.isLoading),
                                                            },
                                                            buttonType: "button",
                                                        }
                                                    ]}
                                                    align="center"
                                                    gap={2}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </>
                            }
                        />
                    </div>
                </div>
                {showConfigModal &&
                    <CommonSelectorModal
                        title="Tax Rounding Config Selector"
                        columns={columns}
                        data={useSearchTaxRoundingConfigQuery}
                        show={showConfigModal}
                        onSubmit={handleOnClick}
                        setShow={setShowConfigModal}
                        setSelectedRow={setSelectedRow}
                    />
                }
            </div>
        </>
    );
};

export default CreateCollector;
